import { notifications } from '@mantine/notifications';
import { useQueryClient } from '@tanstack/react-query';
import { useProfile } from 'init/use-enforce-profile';
import { i18nKeys, useTranslation } from 'locales';
import { z } from 'zod/v4';

import { useCableSubscription } from './use-cable-subscription';

const AgedBalancesMessageSchema = z.object({
  notify_user_ids: z.array(z.number()),
});

export function useAgedBalancesSubscription() {
  const { t } = useTranslation();
  const client = useQueryClient();
  const profile = useProfile();

  const reloadAgedBalances = () => client.invalidateQueries({ queryKey: ['aged-balance'] });

  const reloadAndTellTheRequester = (message: unknown) => {
    reloadAgedBalances();

    const isRequester = AgedBalancesMessageSchema.safeParse(message).data?.notify_user_ids.includes(
      profile.id,
    );
    if (isRequester) notifications.show({ message: t(i18nKeys.ANALYTICS.REFRESH_BALANCE_DONE) });
  };

  useCableSubscription('AgedBalancesChannel', {
    connected: reloadAgedBalances,
    received: reloadAndTellTheRequester,
  });
}
